import React from "react";
import "./Navbar.css";

const Navbar = () => {
    // Lấy full_name từ localStorage, nếu chưa có thì hiển thị mặc định là "Admin" hoặc rỗng
    const fullName = localStorage.getItem("full_name") || "Admin";

    return (
        <div className="navbar">

            {/* Logo bên trái */}
            <div className="navbar-left">
                <img src="/logo/logo-bvbank.png" alt="BVBank Logo" className="navbar-logo" />
            </div>

            {/* User + Avatar bên phải */}
            <div className="navbar-right">
                <div className="navbar-user">
                    <div className="avatar">
                        <img src="/icons/icons8-user-100.png" alt="user Logo" className="user-logo" />
                    </div>
                    {/* Hiển thị biến fullName tại đây */}
                    <span className="username">{fullName}</span>
                </div>
            </div>

        </div>
    );
};

export default Navbar;